import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';
import { setOrderedLegs } from 'Store/actions/horseRacing';
import { classnames } from 'Utils/classnames';
import { useDispatch } from 'react-redux';


const OrderList = ({ legs, selectedLegNo, onItemRemove }) => {

  const [draggingItem, setDraggingItem] = useState(null);
  const dispatch = useDispatch();
  const handleDragStart = (e, horse) => {
    setDraggingItem(horse);
    e.dataTransfer.setData('text/plain', '');
  };

  const  handleDragEnd = () => {
    setDraggingItem(null);
  };

  const  handleDragOver = e => {
    e.preventDefault();
  };

  const  handleDrop = (e, horse) => {
    if (!draggingItem) return;

    const horseList = [...legs[selectedLegNo]];
    const currentIndex = horseList.indexOf(draggingItem);
    const targetIndex = horseList.indexOf(horse);

    if (currentIndex !== -1 && targetIndex !== -1) {
      horseList.splice(currentIndex, 1);
      horseList.splice(targetIndex, 0, draggingItem);
      const newLegs = [...legs];
      newLegs[selectedLegNo] = horseList;
      dispatch(setOrderedLegs(newLegs));
    }
  };


  return <div className="newBetSlip__runs-withComma">
    { !legs[selectedLegNo] ? <div className="horse-item">
      <p className="emptyText">Lütfen at seçiniz
        ardından sürükleyerek bırakınız.</p>
    </div> : legs[selectedLegNo]?.map(horse =>
      <div
        draggable="true"
        onDragStart={ e =>
          handleDragStart(e, horse) }
        onDragEnd={ handleDragEnd }
        onDragOver={ handleDragOver }
        onDrop={ e => handleDrop(e, horse) }
        key={ horse?.uniqId }
        className={ classnames({
          'horse-item': true,
          'item-dragging': draggingItem?.uniqId === horse?.uniqId,
          'item-agf': horse?.agfOrderNo === 1
        }) }
      >
        <p>{ horse?.horseNo }. { horse?.name }</p>
        <div className="buttons">
          { draggingItem?.uniqId === horse?.uniqId ? <Icon iconName="svgDragDropRed" /> : <Icon iconName="svgDragDrop" /> }
          <Icon onClick={ ()=> {
            onItemRemove(selectedLegNo, horse);
          } } iconName="svgCloseGraySolid" />
        </div>
      </div> ) }
  </div>;
};

OrderList.propTypes = {
  legs: PropTypes.object,
  selectedLegNo: PropTypes.number,
  onItemRemove: PropTypes.func,
};
export default OrderList;
